var styles = {"alertContainer":"styles_alert-container__6ACtA","alert":"styles_alert__inRw7"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
